// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__R82wk","inputWrap":"CustomTip_inputWrap__3oixg"};